// useBusEvent.js
import { onMounted, onBeforeUnmount } from 'vue';
import eventBus from '@rebuild/utils/event-bus';

/**
 * 订阅事件总线消息
 * @param {string} event - 事件名
 * @param {Function} handler - 回调函数
 * @param {boolean} once - 是否只执行一次
 */
export function useBusEvent(event, handler, once = false) {
	onMounted(() => {
		if (once) {
			eventBus.once(event, handler);
		} else {
			eventBus.on(event, handler);
		}
	});

	onBeforeUnmount(() => {
		eventBus.off(event, handler);
	});
}
